import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles/UserProfileDropdown.css';
import { logoutSession } from '../utils/api';
import { toast } from 'react-toastify';

function UserProfileDropdown({ user, setUser }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    const handleLogout = async () => {
        const revocation = logoutSession();
        setUser(null);
        navigate('/login');
        if (!await revocation) toast.info(t('logoutPending'));
    };

    const handleEditProfile = () => {
        setIsOpen(false);
        navigate('/edit-profile');
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    if (!user) {
        return null;
    }

    return (
        <div className="user-profile-dropdown" ref={dropdownRef}>
            <div className="avatar" onClick={toggleDropdown}>
                {user.avatar ? (
                    <img 
                        src={user.avatarThumbnail || user.avatar}
                        decoding="async"
                        onError={event => { if (event.currentTarget.src !== user.avatar) event.currentTarget.src = user.avatar; }}
                        alt={`${user.name}'s avatar`} 
                        className="avatar-image"
                    />
                ) : (
                    user.name ? user.name[0].toUpperCase() : '?'
                )}
            </div>
            <div className={`user-dropdown ${isOpen ? 'open' : ''}`}>
                <button onClick={handleEditProfile}>{t('editProfile')}</button>
                <button onClick={handleLogout}>{t('logout')}</button>
            </div>
        </div>
    );
}

export default UserProfileDropdown;
